// import { datadogRum } from '@datadog/browser-rum'
import React from 'react'
import { createRoot } from 'react-dom/client'

// import { DATADOG_IGNORED_ERRORS } from 'settings'

import { App } from './App'

// import type { RumErrorEvent } from '@datadog/browser-rum'

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')

// if (import.meta.env.VITE_DATADOG_APPLICATION_ID && import.meta.env.VITE_DATADOG_CLIENT_TOKEN) {
//   datadogRum.init({
//     applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
//     clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
//     site: 'datadoghq.com',
//     service: 'frogbox-go',
//     env: import.meta.env.VITE_DATADOG_ENV || 'dev',
//     version: `${import.meta.env.VITE_APP_VERSION}.${import.meta.env.VITE_CI_COMMIT_SHORT_SHA ?? 'dev'}`,
//     sessionSampleRate: 100,
//     sessionReplaySampleRate: 100,
//     trackUserInteractions: true,
//     defaultPrivacyLevel: 'mask-user-input',
//     beforeSend: event => {
//       if (event.type === 'error' && 'message' in event) {
//         const errorEvent = event as RumErrorEvent
//         const message = String(errorEvent.message || '')
//         const ignoredMessages = DATADOG_IGNORED_ERRORS
//         if (ignoredMessages.some(msg => message.includes(msg))) {
//           return false
//         }
//       }
//       return true
//     },
//   })
//   datadogRum.startSessionReplayRecording()
// }

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
